<div class="card bg-dark-lighter text-white">
  <div class="card-header">
    {{ "Operator Controller" | uppercase }}
    <button
      type="button"
      data-bs-toggle="modal"
      data-bs-target="#modalManageGroupOperator"
      (click)="addGroup()"
      create-permission
    >
      <i class="fa fa-plus"></i>
      Add Group
    </button>
  </div>
  <div class="card-body">
    <div class="table-responsive">
      <table class="table rox-table table-bordered bg-dark">
        <thead>
          <tr>
            <th>№</th>
            <th>Group Name</th>
            <!-- <th class="text-center">Surveillance</th> -->
            <!--<th class="text-center">wallet</th>-->
            <!-- <th class="text-center">Anti Scalping</th>
            <th class="text-center">NOP</th> -->
            <!-- <th class="text-center">MT5 ME</th> -->
            <th class="text-center">MT5 PE</th>
            <th class="text-center">MT5 Swap</th>
            <!-- <th class="text-center">DBook</th> -->
            <th create-permission></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let group of groups; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ group.name }}</td>
            <!-- <td
              class="text-center"
              [ngStyle]="{
                color: permissionColors[group.permission.opSurveillance]
              }"
            >
              {{ group.getOPSurveillancePermission().toString() }}
            </td> -->
            <!--<td-->
            <!--class="text-center"-->
            <!--[ngStyle]="{ color: permissionColors[group.permission.opWallet] }"-->
            <!--&gt;-->
            <!--{{ group.getOPWalletPermission().toString() }}-->
            <!--</td>-->
            <!-- <td
              class="text-center"
              [ngStyle]="{
                color: permissionColors[group.permission.opAntiScalping]
              }"
            >
              {{ group.getOPAntiScalpingPermission().toString() }}
            </td>
            <td
              class="text-center"
              [ngStyle]="{ color: permissionColors[group.permission.opNop] }"
            >
              {{ group.getOPNopPermission().toString() }}
            </td> -->

            <!-- <td
              class="text-center"
              [ngStyle]="{ color: permissionColors[group.permission.mt5_me] }"
            >
              {{ group.getMEPermission().toString() }}
            </td> -->
            <td
              class="text-center"
              [ngStyle]="{ color: permissionColors[group.permission.mt5_pe] }"
            >
              {{ group.getPEPermission().toString() }}
            </td>

            <td
            class="text-center"
            [ngStyle]="{ color: permissionColors[group.permission.mt5_swap] }"
          >
            {{ group.getSwapPermission().toString() }}
          </td>
            <!-- <td
              class="text-center"
              [ngStyle]="{ color: permissionColors[group.permission.dbook] }"
            >
              {{ group.getDBookPermission().toString() }}
            </td> -->
            <td class="text-right" create-permission>
              <a
                data-bs-toggle="modal"
                data-bs-target="#modalManageGroupOperator"
                (click)="editGroup(group)"
              >
                <i class="fa fa-pencil-square-o"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<!-- GROUP MODAL -->
<div class="modal fade fx-modal" id="modalManageGroupOperator" #modalGroup>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" *ngIf="manageGroupMode === 'Add'">Add Group</h4>
        <h4 class="modal-title" *ngIf="manageGroupMode === 'Edit'">
          Edit Group
        </h4>
        <button type="button" class="close" data-bs-dismiss="modal">
          &times;
        </button>
      </div>

      <!-- Modal body -->
      <div class="modal-body" *ngIf="group">
        <form class="form form-horizontal" #form="ngForm">
          <div class="row form-group">
            <label class="col-md-4 control-label required">Group Name:</label>
            <div class="col-md-8">
              <input
                type="text"
                name="groupName"
                class="form-control bg-dark"
                [(ngModel)]="group.name"
                #groupName="ngModel"
                required
                [disabled]="manageGroupMode === 'Edit'"
              />
              <div
                *ngIf="
                  (showError && groupName.errors) ||
                  (groupName.invalid && (groupName.dirty || groupName.touched))
                "
              >
                <small
                  class="error error-message"
                  [hidden]="!groupName.errors.required"
                  >Required.</small
                >
              </div>
            </div>
          </div>
          <hr />
          <!-- <div class="row form-group">
            <label class="col-md-4 control-label">Surveillance:</label>
            <div class="col-md-8">
              <div class="row">
                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="dashboardOptions"
                      class="mr-3"
                      [(ngModel)]="group.permission.opSurveillance"
                      [value]="0"
                    />
                    <span
                      [ngStyle]="{
                        color: permissionColors[0]
                      }"
                      >N/A</span
                    >
                  </label>
                </div>

                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="dashboardOptions"
                      [(ngModel)]="group.permission.opSurveillance"
                      [value]="1"
                    />
                    <span class="checkmark"></span>
                    <span
                      class="radio-title"
                      [ngStyle]="{
                        color: permissionColors[1]
                      }"
                      >Read</span
                    >
                  </label>
                </div>
                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="dashboardOptions"
                      [(ngModel)]="group.permission.opSurveillance"
                      [value]="2"
                    />
                    <span class="checkmark"></span>
                    <span
                      [ngStyle]="{
                        color: permissionColors[2]
                      }"
                      >Write</span
                    >
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-4 control-label">Anti Scalping:</label>
            <div class="col-md-8">
              <div class="row">
                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="affiliateOptions"
                      [(ngModel)]="group.permission.opAntiScalping"
                      [value]="0"
                    />
                    <span class="checkmark"></span>
                    <span
                      class="radio-title"
                      [ngStyle]="{
                        color: permissionColors[0]
                      }"
                      >N/A</span
                    >
                  </label>
                </div>

                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="affiliateOptions"
                      [(ngModel)]="group.permission.opAntiScalping"
                      [value]="1"
                    />
                    <span class="checkmark"></span>
                    <span
                      class="radio-title"
                      [ngStyle]="{
                        color: permissionColors[1]
                      }"
                      >Read</span
                    >
                  </label>
                </div>
                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="affiliateOptions"
                      [(ngModel)]="group.permission.opAntiScalping"
                      [value]="2"
                    />
                    <span class="checkmark"></span>
                    <span
                      class="radio-title"
                      [ngStyle]="{
                        color: permissionColors[2]
                      }"
                      >Write</span
                    >
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-4 control-label">NOP:</label>
            <div class="col-md-8">
              <div class="row">
                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="kycOptions"
                      [(ngModel)]="group.permission.opNop"
                      [value]="0"
                    />
                    <span class="checkmark"></span>
                    <span
                      class="radio-title"
                      [ngStyle]="{
                        color: permissionColors[0]
                      }"
                      >N/A</span
                    >
                  </label>
                </div>

                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="kycOptions"
                      [(ngModel)]="group.permission.opNop"
                      [value]="1"
                    />
                    <span class="checkmark"></span>
                    <span
                      class="radio-title"
                      [ngStyle]="{
                        color: permissionColors[1]
                      }"
                      >Read</span
                    >
                  </label>
                </div>
                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="kycOptions"
                      [(ngModel)]="group.permission.opNop"
                      [value]="2"
                    />
                    <span class="checkmark"></span>
                    <span
                      class="radio-title"
                      [ngStyle]="{
                        color: permissionColors[2]
                      }"
                      >Write</span
                    >
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-4 control-label">EA:</label>
            <div class="col-md-8">
              <div class="row">
                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="eaOptions"
                      [(ngModel)]="group.permission.ea"
                      [value]="0"
                    />
                    <span class="checkmark"></span>
                    <span
                      class="radio-title"
                      [ngStyle]="{
                        color: permissionColors[0]
                      }"
                      >N/A</span
                    >
                  </label>
                </div>
                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="eaOptions"
                      [(ngModel)]="group.permission.ea"
                      [value]="1"
                    />
                    <span class="checkmark"></span>
                    <span
                      class="radio-title"
                      [ngStyle]="{
                        color: permissionColors[1]
                      }"
                      >Read</span
                    >
                  </label>
                </div>
                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="eaOptions"
                      [(ngModel)]="group.permission.ea"
                      [value]="2"
                    />
                    <span class="checkmark"></span>
                    <span
                      class="radio-title"
                      [ngStyle]="{
                        color: permissionColors[2]
                      }"
                      >Write</span
                    >
                  </label>
                </div>
              </div>
            </div>
          </div> -->

          <!-- <div class="row form-group mb-3">
            <label class="col-md-3 control-label">MT5 ME:</label>
            <div class="col-lg-9">
              <mat-radio-group
                class="row"
                name="meOptions"
                [(ngModel)]="group.permission.mt5_me"
                ngDefaultControl
              >
                <mat-radio-button [value]="0" class="col">
                  <span
                    [ngStyle]="{
                      color: permissionColors[0]
                    }"
                  >
                    N/A
                  </span>
                </mat-radio-button>
                <mat-radio-button [value]="1" class="col">
                  <span
                    [ngStyle]="{
                      color: permissionColors[1]
                    }"
                  >
                    Read
                  </span>
                </mat-radio-button>
                <mat-radio-button [value]="2" class="col">
                  <span
                    [ngStyle]="{
                      color: permissionColors[2]
                    }"
                  >
                    Write
                  </span>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div> -->

          <div class="row form-group mb-3">
            <label class="col-md-3 control-label">MT5 PE:</label>
            <div class="col-lg-9">
              <mat-radio-group
                class="row"
                name="peOptions"
                [(ngModel)]="group.permission.mt5_pe"
                ngDefaultControl
              >
                <mat-radio-button [value]="0" class="col">
                  <span
                    [ngStyle]="{
                      color: permissionColors[0]
                    }"
                  >
                    N/A
                  </span>
                </mat-radio-button>
                <mat-radio-button [value]="1" class="col">
                  <span
                    [ngStyle]="{
                      color: permissionColors[1]
                    }"
                  >
                    Read
                  </span>
                </mat-radio-button>
                <mat-radio-button [value]="2" class="col">
                  <span
                    [ngStyle]="{
                      color: permissionColors[2]
                    }"
                  >
                    Write
                  </span>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>

          <div class="row form-group mb-3">
            <label class="col-md-3 control-label">MT5 Swap:</label>
            <div class="col-lg-9">
              <mat-radio-group
                class="row"
                name="swapOptions"
                [(ngModel)]="group.permission.mt5_swap"
                ngDefaultControl
              >
                <mat-radio-button [value]="0" class="col">
                  <span
                    [ngStyle]="{
                      color: permissionColors[0]
                    }"
                  >
                    N/A
                  </span>
                </mat-radio-button>
                <mat-radio-button [value]="1" class="col">
                  <span
                    [ngStyle]="{
                      color: permissionColors[1]
                    }"
                  >
                    Read
                  </span>
                </mat-radio-button>
                <mat-radio-button [value]="2" class="col">
                  <span
                    [ngStyle]="{
                      color: permissionColors[2]
                    }"
                  >
                    Write
                  </span>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <!-- <div class="row form-group">
            <label class="col-md-4 control-label">DBook:</label>
            <div class="col-md-8">
              <div class="row">
                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="dbookOptions"
                      [(ngModel)]="group.permission.dbook"
                      [value]="0"
                    />
                    <span class="checkmark"></span>
                    <span
                      class="radio-title"
                      [ngStyle]="{
                        color: permissionColors[0]
                      }"
                      >N/A</span
                    >
                  </label>
                </div>
                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="dbookOptions"
                      [(ngModel)]="group.permission.dbook"
                      [value]="1"
                    />
                    <span class="checkmark"></span>
                    <span
                      class="radio-title"
                      [ngStyle]="{
                        color: permissionColors[1]
                      }"
                      >Read</span
                    >
                  </label>
                </div>
                <div class="col">
                  <label class="fx-radio">
                    <input
                      type="radio"
                      name="dbookOptions"
                      [(ngModel)]="group.permission.dbook"
                      [value]="2"
                    />
                    <span class="checkmark"></span>
                    <span
                      class="radio-title"
                      [ngStyle]="{
                        color: permissionColors[2]
                      }"
                      >Write</span
                    >
                  </label>
                </div>
              </div>
            </div>
          </div> -->
        </form>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-red" (click)="save()">Save</button>
        <button type="button" class="btn btn-default" data-bs-dismiss="modal">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
